module.exports = __webpack_public_path__ + "img/image_1.e408d2a9.jpg";